import { UserType } from "./user.dtos";
export function checkUserType(anyUser, ...types) {
    if (types.includes(anyUser.type)) {
        return anyUser;
    }
    else {
        return null;
    }
}
export function assertUserType(anyUser, ...types) {
    if (types.includes(anyUser.type)) {
        return anyUser;
    }
    else {
        throw new Error(`Unexpected user type: ${anyUser.type}`);
    }
}
export function checkUserTypeOptional(anyUser, ...types) {
    return anyUser === null ? null : checkUserType(anyUser, ...types);
}
export function assertUserTypeOptional(anyUser, ...types) {
    return anyUser === null ? null : assertUserType(anyUser, ...types);
}
export function isOrganizationUserType(type) {
    return type === UserType.HEALTHCARE_ORGANIZATION || type === UserType.EXTERNAL_RESEARCHER || type === UserType.SERVICE_PROVIDER;
}
